import React, { useState, useEffect } from 'react';
import Image from 'next/image';
import { Box, Modal, IconButton, CircularProgress } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const ImageModal = ({ isOpen, onClose, imageSrc, altText, next, previous }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true); // Start loading when modal opens or imageSrc changes
  }, [imageSrc]);

  const handleImageLoad = () => {
    setLoading(false); // Stop loading when image is fully loaded
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="image-modal-title"
      aria-describedby="image-modal-description"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box sx={{ position: 'relative', outline: 'none' }}>
        {previous && (
          <IconButton 
            sx={{ 
              position: 'absolute', 
              left: 0, 
              top: '50%', 
              transform: 'translateY(-50%)', 
              backgroundColor: 'rgba(0, 0, 0, 0.5)', 
              color: 'white',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
              },
            }} 
            onClick={previous}
          >
            <ArrowBackIcon />
          </IconButton>
        )}
        {loading && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
            }}
          >
            <CircularProgress />
          </Box>
        )}
        <Image src={imageSrc} alt={altText} width={800} height={600} onLoad={handleImageLoad} />
        {next && (
          <IconButton 
            sx={{ 
              position: 'absolute', 
              right: 0, 
              top: '50%', 
              transform: 'translateY(-50%)', 
              backgroundColor: 'rgba(0, 0, 0, 0.5)', 
              color: 'white',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
              },
            }} 
            onClick={next}
          >
            <ArrowForwardIcon />
          </IconButton>
        )}
      </Box>
    </Modal>
  );
};

export default ImageModal;
